import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { AppService } from '../../app.service';

@Component({
  selector: 'site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLinkActive],
})
export class SiteFooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  public isTeamLeader: boolean = false;

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.isTeamLeader = this.appService.getCurrentTeamMember().isTeamLeader;
  }
}
